import { useTranslation } from 'react-i18next'

export default function useApplyV2NavTranslations() {
    const { t } = useTranslation()

    const navTranslations: Record<string, string> = {
        profile: t('4647', 'Profile'),
        cv: t('4836', 'Upload CV'),
        questions: t('5655', 'Questions'),
        education: t('78', 'Education'),
        languages: t('3296', 'Languages'),
        // license: t('97', 'Driver license'),
        license: t('6717', 'Driving License'),
        skills: t('76', 'Skills'),
        reviewApply: t('10189', 'Review & Apply'),
        course: t('10309', 'Courses'),
        // driverLicence: t('10191', 'Driver Licence'),
        driverLicence: t('1267', 'Driver license'),
        // driverLicence: t('97', 'Driver license'),
        language: t('95', 'Language'),
        reference: t('1208', 'References'),
        skill: t('76', 'Skills'),
        workExperience: t('80', 'Work Experience'),
        question: t('5655', 'Questions'),
    }

    const getTitle = (key: string, fallback = key, options?: Record<string, any>): string => {
        const nav = navTranslations[key]
        const fall = t(key, fallback)
        if (key === 'driverLicence') {
            // console.log(key, nav, t('97'), t('1267'), t('10191'))
        }
        return navTranslations[key] ?? t(key, fallback, options)
    }

    return {
        navTranslations,
        getTitle,
    }
}
